"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cache = void 0;
var _nodeCache = _interopRequireDefault(require("node-cache"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//Based on https://medium.com/@danielsternlicht/caching-like-a-boss-in-nodejs-9bccbbc71b9b

class Cache {
  constructor(ttlSeconds) {
    this.cache = new _nodeCache.default({
      stdTTL: ttlSeconds,
      checkperiod: ttlSeconds * 0.2,
      useClones: false
    });
  }
  get(key, storeFunction) {
    const value = this.cache.get(key);
    if (value) {
      return Promise.resolve(value);
    }
    return storeFunction().then(result => {
      this.cache.set(key, result);
      return result;
    });
  }
  del(keys) {
    this.cache.del(keys);
  }
  delStartWith(startStr = '') {
    if (!startStr) {
      return;
    }
    const keys = this.cache.keys();
    for (const key of keys) {
      if (key.indexOf(startStr) === 0) {
        this.del(key);
      }
    }
  }
  flush() {
    this.cache.flushAll();
  }
}
exports.Cache = Cache;